import React, { useEffect, useMemo, useState } from "react";
import "./SwitchingorderType.scss";
import { useSelector } from "react-redux";
import cancelIcon from "../../common/assets/svg/cancelIconnew.svg";
import infoIcon from "../../common/assets/svg/infoiconnew.svg";
import { currentOrderType, getRestaurantMenuDetails } from "../../common/features/restaurant/restaurantAction";
import { useDispatch } from "react-redux";
import { startEmptyCartOrder } from "../../common/features/order/orderActions";
import { clearRunningCart, removeCartItem, removeCartItemOrderType } from "../../common/features/cart/cartActions";

const SwitchingorderType = ({
  isOpen,
  onClose,
  currentOrdertypeDetails,
  onToggle,
  type
}: any) => { 
  const isMobile = useSelector((state:any)=>state?.navigation?.isMobile)
  // const restaurantDetails = useSelector(
  //   (state: any) => state.restaurant.currentRestaurantDetail
  // );
  // const slugFromLocalStorage = JSON.parse(localStorage.getItem('restaurant') || '');
  // const customerId = getCookie(USER_ID)
 
  // const dispatch = useDispatch();

  const handleProceed = () => {
    onToggle(type)
    // let payload = {
    //   type: slugFromLocalStorage?.menuType,
    //   locationId: restaurantDetails.id,
    //   customerId: customerId,
    //   searchText: null,
    //   visibleTo: "C",
    // }
    // // dispatch(removeCartItemOrderType())
    // dispatch(getRestaurantMenuDetails(payload));
    onClose()
  };
  useEffect(() => {
    if (isOpen) {
      document.documentElement.classList.add("no-scroll"); 
    } else {
     
      document.documentElement.classList.remove("no-scroll");
    }
  
    return () => {
      document.documentElement.classList.remove("no-scroll");
    };
  }, [isOpen]);
  
  if (!isOpen) return null;

  return (
    <div className="popup-overlayZa">
      <div className="popup-contentZa" style={{width:isMobile?"100%":"400px"}}>
        <button className="close-btnZa" onClick={onClose}>
          <img src={cancelIcon} alt="" />
        </button>

        <div className="switching-order-type-note-container-main">
          <img
            src={infoIcon}
            alt=""
            // style={{marginTop:isMobile?'-8rem':"-7rem"}}
            className="switching-order-type-note-container-main-icon"
          />
          <div className="switching-order-type-note-container">
            <span className="note-text note-heading">Switching to Pickup or Delivery:</span>

            <span className="note-text">
              Please note that some items in your cart may not be available.
            </span>

            <span className="note-text-bold">Would you like to continue?</span>
          </div>
        </div>

        <button className="switching-order-type-button" onClick={handleProceed}>
          Proceed
        </button>
        {/* <button className="close-btnZa" onClick={onClose}>Close</button> */}
      </div>
    </div>
  );
};

export default SwitchingorderType;
